<template>
    <div v-show="shouldShowCheckBox()" class="fill-checkbox abc-checkbox abc-checkbox-circle abc-checkbox-success mt--3">
        <input type="checkbox"
               @change="changePaidAmountField"
               :id="`${isDesktopView ? 'desktop-' : 'mobile-'}populate-paid-amount-input-${index}`" v-model="autoPopulatePaidAmount" />
        <label :for="`${isDesktopView ? 'desktop-' : 'mobile-'}populate-paid-amount-input-${index}`" class="pl-20" style="padding-top: 8px"></label>
    </div>

</template>

<script>
import {ref} from 'vue';
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index : {
            type: Number,
            required: true,
        },
        shouldPopulatePaidAmount: {
            type: Boolean,
            required: true,
        },
        populatePaidAmount: {
            type: Function,
            required: true,
        },
        isDesktopView: {
            type: Boolean,
            required: true,
        }
    },
    setup(props) {
      return {
          autoPopulatePaidAmount: ref(props.shouldPopulatePaidAmount),
      }
    },
    methods: {
        shouldShowCheckBox() {
            return (this.entry.amount - this.entry.waived_amount) > 0;
        },
        changePaidAmountField() {
            this.populatePaidAmount(this.index, this.autoPopulatePaidAmount);
        },
    }
}
</script>

<style scoped>
    .fill-checkbox.abc-checkbox label::before,
    .fill-checkbox.abc-checkbox label::after {
        padding-left: 0;
    }
    #fees-collections-mobile .abc-checkbox label::after {
        left: -6px;
    }
</style>
